import {AbstractControl, ValidatorFn} from '@angular/forms';

import {FileTypeValidatorKey} from './custom-validator-keys';

export function FileTypeValidator(
    checkControl = true,
    fileType?: string,
    wantsPdf = true
): ValidatorFn {
    return (control: AbstractControl): { [FileTypeValidatorKey]: boolean } | null => {
        const type = !checkControl ? fileType : (control.value as File).type;
        const types = ['image/jpg', 'image/jpeg', 'image/png'];

        if (wantsPdf) {
            types.push( 'application/pdf');
        }

        return (types.indexOf(type) < 0) ? {[FileTypeValidatorKey]: true} : null;
    };
}
